import { Component, Input, OnInit } from '@angular/core';
import { Articolo } from 'app/core/models/articolo';
import { PageTitleService } from 'app/core/page-title/page-title.service';
import { CinetykApiService } from 'app/core/services/cinetyk-api.service';
import { MainComponent } from 'app/main/main.component';

@Component({
  selector: 'app-articolo-view',
  templateUrl: './articolo-view.component.html',
  styleUrls: ['./articolo-view.component.css']
})
export class ArticoloViewComponent implements OnInit {

  constructor(private cinetykApiService : CinetykApiService,  private pageTitleService: PageTitleService, private main: MainComponent) {
    this.main.showThrobber()
   }
  @Input() idArticolo : number;

  testo:string;
  articolo:Articolo;

  ngOnInit(): void {
    this.cinetykApiService.getArticoloById(this.idArticolo).subscribe((a:Articolo)=>{
      this.pageTitleService.setTitle(a.titolo);
      this.pageTitleService.setSubTitle('');
      this.articolo = a;
      this.main.hideThrobber();
    })
    
    //this.main.imgSrc = 'assets/img/index-banner.jpg';
  }
  getHTML(d:string){
		if(d)
		return JSON.parse(d).HTML;
	}
}
